import React from "react";

import { NavLink } from "react-router-dom";

import {
  SidebarMenu as SidebarMenuTelluriaUi,
  SidebarMenuProps as SidebarMenuPropsTelluriaUi
} from "@npm-telluria-tecnologia/telluria-ui";

interface SidebarMenuProps extends SidebarMenuPropsTelluriaUi {
  link: string;
  end?: boolean;
}

const SidebarMenu: React.FC<SidebarMenuProps> = ({ id, title, icon, identifierColor, link, end }) => (
  <NavLink to={link} end={end}>
    <SidebarMenuTelluriaUi
      key={`${id}_${title}`}
      id={id}
      title={title}
      icon={icon}
      identifierColor={identifierColor}
    />
  </NavLink>
);

SidebarMenu.defaultProps = {
  end: false
};

export default SidebarMenu;
